<template>
  <Wrapper tableType="white">
    <div class="own-reports">
      <header class="own-reports-header">
        <div class="tabs desktop">
          <span
            v-if="accessCache['planning']"
            class="tab"
            :class="{ 'tab-active': tab === 'planned' }"
            @click="changeTab('planned')"
            >ПЛАНИРАНИ ОТЧЕТИ</span
          >
          <span
            v-if="accessCache['reporting']"
            class="tab"
            :class="{ 'tab-active': tab === 'last' }"
            @click="changeTab('last')"
            >РЕАЛНИ ОТЧЕТИ</span
          >
          <span
            v-if="canSeeSelfReportsTab()"
            class="tab"
            :class="{ 'tab-active': tab === 'selfReports' }"
            @click="changeTab('selfReports')"
            >САМООТЧЕТИ ОТ РАБОТНИЦИ</span
          >
        </div>
        <!-- <h2 v-if="!reports.length">Моите отчети</h2>
      <h2 v-else>Моите последно направени отчети</h2>-->
        <div class="btns">
          <TheInput
            v-if="tab === 'selfReports'"
            showAsIcon="g"
            prop="name"
            propValue="value"
            type="dropdown"
            :fixed="true"
            :options="filters"
            fixedLabel="ФИЛТРИРАЙ САМООТЧЕТИТЕ"
            v-model="selfReportsFilter"
            @update:modelValue="setFilter($event)"
          />
          <button
            v-if="tab !== 'selfReports'"
            class="btn btn-plan"
            @click="newReport(true)"
          >
            <span class="mck2">I</span>
            Ново планиране
          </button>

          <button
            class="btn btn-new"
            v-if="canSeeNewReportBtn()"
            @click="tab === 'selfReports' ? newSelfReport() : newReport()"
          >
            <span class="mck">H</span>
            Нов отчет
          </button>
        </div>
      </header>
      <main class="table-wrapper">
        <template v-if="!isMobile">
          <p v-if="!reports.length" class="no-reports">
            Нямате направени отчети
          </p>
          <table v-else class="table" ref="table">
            <thead>
              <tr>
                <th class="eye-cell"></th>
                <th
                  class="clickable"
                  @click="toggleSort()"
                  :class="{ 'clickable--active': sort === 'date' }"
                >
                  Дата
                </th>
                <th v-if="tab !== 'selfReports'">Отчетник</th>
                <th v-else>Работник</th>
                <th>Отдел</th>
                <th :style="tab === 'selfReports' ? 'width: 400px' : ''">
                  Проект
                </th>
                <template v-if="tab !== 'selfReports'">
                  <th class="center">Отчетени хора</th>
                  <th class="center">Отчетени собствени механизации</th>
                  <th class="center">Отчетени наети механизации</th>
                  <th class="center">Отчетени материали</th>
                  <th class="center">Отчетени дейности</th>
                </template>
                <template v-else>
                  <th class="center">Забележка от работника</th>
                  <th style="width: 200px" class="center">Потвърден</th>
                  <th class="center">Проверен от</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="report in reports"
                :key="`findReport-${report._id}`"
                @click="viewReport(report._id)"
                :class="{
                  'tr-invalid': report.isInvalid,
                  'tr-planned': tab === 'planned',
                }"
              >
                <td class="eye-cell">
                  <span v-if="report.allVisible">👁️</span>
                </td>
                <td class="eye-cell">
                  <span class="no-wrap">{{ report.date | formatDate }} г.</span>
                </td>
                <td v-if="tab !== 'selfReports'">
                  {{ report.createdBy.name }}
                </td>
                <td v-else>{{ getReportWorker(report).name }}</td>

                <td class="td-company-name">
                  <img
                    class="td-invalid-flag"
                    v-if="report.isInvalid"
                    src="../assets/img/flag_yes.svg"
                    alt="invalid"
                  />
                  {{ report.company.companyName }}
                </td>
                <td>
                  <div class="project-name">
                    <p>{{ report.project.projectName }}</p>
                    <TheInput
                      v-if="tab === 'selfReports'"
                      type="dropdown"
                      :disabled="isSelfReportsActionsDisabled()"
                      :options="report.project.parts"
                      :value="getPart(report)"
                      @update:modelValue="setPart($event, report)"
                    />
                  </div>
                </td>
                <template v-if="tab !== 'selfReports'">
                  <td
                    class="center underline-hover"
                    :title="report.workersList"
                  >
                    {{ report.workers.length }}
                  </td>
                  <td class="center">{{ report.mechanizations.length }}</td>
                  <td class="center">
                    {{ report.rentedMechanizations.length }}
                  </td>
                  <td class="center">{{ report.materials.length }}</td>
                  <td class="center">{{ report.activities.length }}</td>
                </template>
                <template v-else>
                  <td>
                    <p class="center underline-hover">
                      {{ getWorkerTask(report).name }}
                    </p>
                  </td>
                  <td class="center">
                    <TheInput
                      v-if="!report.checkedBy"
                      type="dropdown"
                      :options="['ПРИЕМИ ОТЧЕТА', 'ОТКАЖИ ОТЧЕТА']"
                      placeholder="Действия"
                      :disabled="isSelfReportsActionsDisabled()"
                      @update:modelValue="
                        setSelfReportStatus($event === 'ПРИЕМИ ОТЧЕТА', report)
                      "
                    />
                    <p v-else>
                      {{
                        report.isSelfReportConfirmed ? "Потвърден" : "Отказан"
                      }}
                    </p>
                  </td>
                  <td class="center">
                    {{ report.checkedBy ? report.checkedBy.name : "-" }}
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </template>
        <section class="mobile-reports" v-else>
          <!-- only for self reports for now -->
          <div
            v-for="r in reports"
            :key="`findReport-${r._id}`"
            class="mobile-reports_report"
            :class="`mobile-reports_report--${getBtnInfo(r).class}`"
            @click="handleMobileReportClick(r)"
          >
            <section class="report-info">
              <aside>
                <div>
                  <span class="mck3">L</span>
                  <span class="no-wrap">{{ r.date | formatDate }} г.</span>
                  -<span>
                    {{
                      calculateHours(
                        r.date,
                        getReportWorker(r).startHour,
                        getReportWorker(r).endHour
                      ).total
                    }}
                  </span>
                  /<span>{{ r.createdBy.name }}</span>
                </div>
                <div>
                  <span class="mck3">M</span>
                  <span>{{ r.project.projectName }}</span>
                </div>
                <div>
                  <span class="mck3">N</span>
                  <span>{{ getWorkerTask(r).name }}</span>
                </div>
              </aside>
              <button>
                <span class="mck3">{{ getBtnInfo(r).icon }}</span>
                <p>{{ getBtnInfo(r).name }}</p>
              </button>
            </section>
            <transition name="fade">
              <section v-if="r.isMenuOpen" class="decision-menu">
                <p @click.stop.prevent="togglePartsMenu(r)">
                  ИЗБЕРИ ЧАСТ И ПРИЕМИ ОТЧЕТА
                </p>
                <p @click.stop="setSelfReportStatus(false, r)">ОТКАЖИ ОТЧЕТА</p>

                <TheFixedDropdown
                  v-if="r.showPartsMenu"
                  label="Избери част"
                  :arr="r.project.parts"
                  @selected="setPart($event, r)"
                  @close="r.showPartsMenu = false"
                />
              </section>
            </transition>
          </div>
        </section>
        <Pagination
          :currentPage="page"
          :size="size"
          :total="total"
          @updage:page="pageChanged"
        />
      </main>

      <SelfReportModal
        v-if="openSelfReportModal"
        @close="closeSelfReportModal"
      />
    </div>
  </Wrapper>
</template>

<script>
import { mapGetters } from "vuex";
import { getAccess } from "./mixins/getAccess.js";
import Vue from "vue";
import hours from "./mixins/hours.js";
import getMobile from "./mixins/getMobile.js";
import SelfReportModal from "./shared/SelfReportModal.vue";
import TheInput from "@/components/TheInput";
import TheFixedDropdown from "@/components/TheFixedDropdown";
import Pagination from "@/components/shared/Pagination";
import Wrapper from "@/components/Wrapper";
export default {
  mixins: [getMobile, hours],
  components: {
    SelfReportModal,
    TheInput,
    TheFixedDropdown,
    Pagination,
    Wrapper,
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  data() {
    return {
      filters: [
        {
          name: "Всички",
          value: "",
        },
        {
          name: "Само потвърдени",
          value: "true",
        },
        {
          name: "Само непотвърдени",
          value: "false",
        },
      ],
      accessCache: {},
      reports: [],
      sort: this.$route.query.sort || "date",
      page: Number.parseInt(this.$route.query.page) || 1,
      size: 40,
      total: 0,
      search: "",
      tab: "planned",
      openSelfReportModal: false,
      selfReportsFilter: { value: "" },
      accessNames: {
        planning: "planned",
        reporting: "last",
        self_reports: "selfReports",
        self_reports_groups: "selfReports",
        accept_self_reports: "selfReports",
        accept_own_project_reports: "selfReports",
      },
    };
  },
  watch: {
    $route: "getReports",
    // sort: "getReports",
    // tab: "getReports",
    search: "getReports",
    isMobile: "switchToSelfReports",
  },
  methods: {
    setFilter(f) {
      const query = { ...this.$route.query };
      this.page = 1;
      query.page = this.page;
      this.selfReportsFilter = f;

      if (!f.value) delete query.isSelfReportConfirmed;
      else query.isSelfReportConfirmed = f.value;

      this.$router.push({ path: this.$route.path, query }).catch(() => {});
    },
    canSeeNewReportBtn() {
      if (this.tab === "selfReports") {
        return (
          this.accessCache["self_reports"] ||
          this.accessCache["self_reports_groups"]
        );
      } else {
        let accessFor = this.tab === "planned" ? "planning" : "reporting";
        return this.accessCache[accessFor];
      }
    },
    canSeeSelfReportsTab() {
      return (
        this.accessCache["self_reports"] ||
        this.accessCache["self_reports_groups"] ||
        this.accessCache["accept_self_reports"] ||
        this.accessCache["accept_own_project_reports"]
      );
    },
    isSelfReportsActionsDisabled() {
      return (
        !this.accessCache["accept_self_reports"] &&
        !this.accessCache["accept_own_project_reports"]
      );
    },
    getBtnInfo(report) {
      if (report.isSelfReportConfirmed === true) {
        return { icon: "I", name: "ПРИЕТ ОТЧЕТ", class: "confirmed" };
      } else if (report.isSelfReportConfirmed === false) {
        return { icon: "K", name: "ОТКАЗАН ОТЧЕТ", class: "declined" };
      } else {
        return { icon: "J", name: "ЧАКА ПРИЕМАНЕ" };
      }
    },
    togglePartsMenu(r) {
      this.$set(r, "showPartsMenu", !r.showPartsMenu);
    },
    handleMobileReportClick(r) {
      if (this.accessCache["accept_self_reports"]) {
        if (!r.checkedBy) this.$set(r, "isMenuOpen", !r.isMenuOpen);
      } else {
        this.viewReport(r._id);
      }
    },
    // switch to selfReorts if its mobile (for now)
    switchToSelfReports() {
      if (this.isMobile) this.tab = "selfReports";
    },
    async setSelfReportStatus(v, r) {
      if (v && !this.getReportWorker(r).part) {
        return this.$snotify.warning("Трябва да изберете част първо");
      }

      try {
        r.isSelfReportConfirmed = v;
        Vue.set(r, "checkedBy", this.getUser);
        let url = `${process.env.VUE_APP_BASE_URI}/report/${r._id}`;

        await this.$http.put(url, r);
        // this.getReports();
      } catch (err) {
        console.log(err);
      }
    },
    setPart(part, report) {
      this.getReportWorker(report).part = part;

      this.setSelfReportStatus(true, report);
      report.showPartsMenu = false;
      report.isMenuOpen = false;
    },
    getReportWorker(report) {
      if (report.workers.length) {
        return report.workers[0];
      } else return {};
    },
    getPart(report) {
      const part = this.getReportWorker(report).part;
      return part ? part : "Избери част";
    },
    getWorkerTask(report) {
      let worker = this.getReportWorker(report);
      if (worker.tasks && worker.tasks.length) {
        return worker.tasks[0];
      } else return "";
    },
    changeTab(t) {
      let query = { tab: t };

      if (t === "selfReports" && this.$route.query.createdAt) {
        query.createdAt = this.$route.query.createdAt;
      } else delete query.createdAt;

      if (this.page !== 1) {
        this.page = 1;
        query.sort = this.sort;
        query.page = this.page;
      }

      this.tab = t;
      this.$router.push({ path: this.$route.path, query }).catch(() => {});
    },
    toggleSort() {
      this.sort = this.sort === "date" ? "createdAt" : "date";
      this.$router.push(`?sort=${this.sort}&page=${this.page}`);
    },
    prevPage() {
      this.page -= 1;
      this.$router.push(`?sort=${this.sort}&page=${this.page}`);
    },
    nextPage() {
      this.page += 1;
      this.$router.push(`?sort=${this.sort}&page=${this.page}`);
    },
    viewReport(id) {
      this.$router.push(`/reports/edit/${id}`);
    },
    getWorkersList(r) {
      let workers = [];
      for (let w of r.workers) {
        workers.push(w.name);
      }
      return workers.join(", ");
    },
    pageChanged(page) {
      this.page = page;
      this.getReports();
    },
    getReports() {
      this.$store.dispatch("startLoading");
      let id = this.getUser._id;
      let url = `${process.env.VUE_APP_BASE_URI}/report/myreports/${id}?sort=${this.sort}&page=${this.page}&size=${this.size}`;

      if (this.tab === "planned") {
        url += "&planned=true";
      } else if (this.tab === "last") {
        url += "&planned=false";
      } else if (this.tab === "selfReports") {
        url += "&isSelfReport=true";

        if (this.$route.query.createdAt) {
          url += `&createdAt=${this.$route.query.createdAt}`;
        }
      }
      if (this.search) {
        url += `&search=${this.search}`;
      }
      if (this.$route.query.isSelfReportConfirmed) {
        url += `&isSelfReportConfirmed=${this.$route.query.isSelfReportConfirmed}`;
      }

      this.$http
        .get(url)
        .then((response) => {
          if (response.data) {
            this.reports = response.data.reports;
            this.reports.map((r) => {
              r.workersList = this.getWorkersList(r);
            });
            // this.total = Math.ceil(response.data.total / this.size);
            this.total = response.data.total;
          }
          this.$store.dispatch("stopLoading");
          // console.log(this.reports.map(r=>r.company.companyName));
        })
        .catch((err) => {
          if (err.response) {
            this.$snotify.error(err.response.data);
          } else {
            console.log(err);
          }
        });
    },
    newReport(plan) {
      // let accessFor = plan ? "planning" : "reporting";

      // if (getAccess(accessFor, "reports", true)) {
      this.$router.push("/reports/new" + (plan ? "?plan=true" : ""));
      // }
    },
    newSelfReport() {
      // if (getAccess("self_reports", "reports", true)) {
      this.openSelfReportModal = true;
      // }
    },
    closeSelfReportModal(updated) {
      this.openSelfReportModal = false;
      if (updated) this.getReports();
    },
    setAccessCache() {
      Object.keys(this.accessNames).forEach((key) => {
        this.accessCache[key] = getAccess(key, "reports");
      });
    },
  },
  mounted() {
    this.setAccessCache();

    const queryTab = this.$route.query.tab;
    let tabSelected = false;

    if (queryTab) {
      for (const [key, value] of Object.entries(this.accessNames)) {
        if (value === queryTab && this.accessCache[key]) {
          this.changeTab(queryTab);
          tabSelected = true;
          break;
        }
      }
    }

    if (!tabSelected) {
      for (const [key, value] of Object.entries(this.accessNames)) {
        if (this.accessCache[key]) {
          this.changeTab(value);
          break;
        }
      }
    }

    // if (this.$route.query.tab === "reports") {
    //   this.changeTab("last");
    // } else {
    //   if (this.$route.query.tab) this.changeTab(this.$route.query.tab);
    //   else this.changeTab("planned");
    // }
    this.getReports();
  },
  updated() {
    // Handle search input
    this.$root.$on("sendSearchInput", (data) => {
      this.search = data.toLowerCase();
      // console.log(this.search);
    });
  },
  destroyed() {
    this.$root.$off("sendSearchInput");
  },
};
</script>

<style scoped lang="scss">
// .table-wrapper {
// overflow: auto;
// min-height: 300px;
// }
.mobile-reports {
  display: flex;
  flex-direction: column;
  gap: 5px;

  .mobile-reports_report {
    background: #d184001a;
    border: 1px solid #d18400;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 5px;

    &.mobile-reports_report--confirmed {
      background: #417e0c1a;
      border-color: #417e0c;
      .report-info {
        button {
          background: #417e0c;
        }
      }
    }
    &.mobile-reports_report--declined {
      background: #4e00001a;
      border-color: #9b110c;
      .report-info {
        button {
          background: #980000;
        }
      }
    }

    .report-info {
      display: flex;

      aside {
        display: flex;
        flex-direction: column;
        gap: 8px;
        flex-grow: 2;

        > div {
          align-items: center;
          display: flex;
          gap: 5px;

          .mck3 {
            font-size: 16px;
          }
        }
      }

      button {
        border-radius: 5px;
        background: #d18400;
        border: none;
        color: #ffffff;
        font-size: 11px;
        height: 75px;
        width: 75px;

        span {
          margin-bottom: 5px;
          display: block;
          font-size: 25px;
        }
      }
    }

    .decision-menu {
      p {
        background: #417e0c;
        border-radius: 4px;
        color: #ffffff;
        text-align: center;
        font-weight: bold;
        padding: 10px;

        &:last-of-type {
          background: #7e0c0c;
          margin-top: 5px;
        }
      }
    }
  }
}

.no-reports {
  background-color: #f0f0f7;
  font-size: 18px;
  text-align: center;
  padding: 20px;
}
.clickable {
  color: var(--color-main);
  cursor: pointer;
}
.clickable--active {
  text-decoration: underline;
}
.clickable:hover {
  opacity: 0.7;
}
.underline-hover {
  color: var(--color-main);
  font-weight: 700;
}
.underline-hover:hover {
  text-decoration: underline;
}
.project-name {
  align-items: center;
  display: flex;
  gap: 5px;

  p {
    flex-basis: 30%;
    // width: calc(100% - 20px);
  }
  .the-input {
    flex-grow: 2;
  }
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .table-wrapper {
    overflow: auto;
  }
  .own-reports {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 15px;
  }
  .own-reports-header {
    .btns {
      width: 100%;
      .btn {
        margin-left: initial;
        width: 100%;
      }
    }
  }
  .btns.mobile {
    position: fixed;
    display: flex;
    float: left;
    flex-direction: column-reverse;
    justify-items: flex-end;
  }
}
</style>
